<template>
  <v-container fill-height 
  :style="{
  minHeight: $vuetify.breakpoint.xsOnly ? 'calc(100vh - 300px)' : 
  $vuetify.breakpoint.smOnly ? 'calc(100vh - 300px)' :
  'calc(100vh - 150px)'
}">
       <v-card  v-if="sendlinksuccess" width="500"  max-width="500" class="mx-auto my-6 pa-4" :elevation="2" style="border-radius:30px;
       box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <v-card-title class="justify-center font-weight-bold text-sm-h5">{{
          this.lg_reset_password.reset_title
        }}</v-card-title>
        <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_reset_password.reset_subtitle1}}
        </v-col>
        </v-row>

           <v-row>
           <v-col justify="center" align="center" cols="12" class="ml-n4 mt-n6">
           <v-btn
                text
                class="mb-1 blue--text rounded-pill text-decoration-underline"
                width="300"
                height="40"
                 @click="onClickMenu('/login-account')"
              >
              {{ this.lg_reset_password.reset_btn }}
              </v-btn>
        </v-col>
        </v-row>
      </v-card>

      <v-card v-else width="500"  max-width="500" class="mx-auto my-6 pa-4" :elevation="2" style="border-radius:30px;
      box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <!-- <v-row>
           <v-col justify="center" align="left" cols="12">
           <v-btn
                icon
                class="mb-1 black--text"
                 @click="onClickMenu('/login-account')"
              >
               <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
        </v-col>
        </v-row> -->
        <v-card-title class="justify-center font-weight-bold text-sm-h5">{{
          this.lg_reset_password.title
        }}</v-card-title>
        <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_reset_password.subtitle1}}
        </v-col>
        </v-row>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-form @submit.prevent="submit" v-model="valid" ref="form" >
              <v-row class="mt-8" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="10" lg="10" md="10" sm="12" xs="12">
             <v-text-field
              :placeholder="this.lg_reset_password.new_password"
              v-model="account.password"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              prepend-inner-icon="mdi-lock"
              @click:append="e1 = !e1"
              :type="e1 ? 'password' : 'text'"
              required
              dense
              outlined
              :rules="passwordRules"
            />

            <v-text-field
              class="mt-4"
              :placeholder="this.lg_reset_password.confirm_password"
              v-model="account.confirm_password"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              prepend-inner-icon="mdi-lock"
              @click:append="e1 = !e1"
              :type="e1 ? 'password' : 'text'"
              required
              dense
              outlined
              :rules="passwordConfirmRules"
            />
            </v-col>
                </v-row>

                 <v-row class="mx-sm-4 mt-n6">
           <v-col justify="center" align="left" cols="12">
        <p class="text-caption">{{ this.lg_reset_password.subtitleforemail }}</p>
        </v-col>
        </v-row>
        

           <v-row class="mt-4" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <v-btn
                type="submit"
                class="mb-1 white--text slide-btn"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }"
                outlined
              >
              {{ this.lg_reset_password.title }}
              </v-btn>
              </v-col>
              </v-row>

              <v-row class="mx-sm-4">
           <v-col justify="center" align="left" cols="12">
        {{ this.lg_reset_password.subtitle2 }}
        </v-col>
        </v-row>
          </v-form>
        </v-card-text>
      </v-card>



    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script lang="js">

import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { server } from "../services/constants";
import { feature } from "../services/constants";
import { lg_reset_password } from "./language/lg_reset_password.js";
import { error } from "pdf-lib";

  export default  {
    name: 'reset',
    props: [],
    created() {
    },
    components: {
      LoadingDialog,
    },
    mounted () {
      localStorage.setItem(server.MEET_STA, "false");
      const token = this.$route.query.token
      const id = this.$route.query.id
      if (api.isLoggedIn() || !token || !id){
        this.$router.push("/")
      }
    },
    data () {
          return {
            messageAlert: "Email หรือ Password ไม่ถูกต้อง กรุณาตรวจสอบข้อมูล",
            account:{
              password:"",
              confirm_password: ""
            },
            valid: false,
            e1: true,
            passwordRules: [],
            passwordConfirmRules: [],
            email: '',
            emailRules: [
              (v) => !!v || 'Please enter your email address',
            ],
              isRequired: true,
              isRequired2:true,
            sendlinksuccess:false,
          }
        },
        methods: {
          async submit() {
             if (this.$refs.form.validate()) {
            // this.$store.state.loadMenu=true;
            this.$swal.showLoading();
              try {
                const token = this.$route.query.token
                const id = this.$route.query.id
                const password = this.account.password
                const body = {token, id, password}
                const res = await api.resetPasswordByUsername(body);
                   // this.$store.state.loadMenu=false;
                this.$swal.close();
             
                if(res.data && res.data.reset) {
                    // alert('Password Reset Successfully')
                    // this.$router.push("/login-account")
                     await this.clear();
                  this.sendlinksuccess = true;
                  return;
                } else {
                    // alert('Something went wrong')
                     this.$swal.fire("Error", res.data.message, "error");
                    return;
                }
              }
              catch (e) {
                 this.$swal.fire("Error", error.message, "error");
                  return;
                //  this.$store.state.loadMenu=false;
              }
            // }
            console.log("Click Submin not if");

            this.$store.state.loadMenu = false;
             }
          },
             onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
          clear () {
            this.$refs.form.reset()
          },

        },
        beforeCreate() {
       window.scrollTo( screen.width/2, screen.height/2 );
      this.$store.state.page_reload = false;
      this.$store.state.altLogin = false;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_reset_password = lg_reset_password.lg_reset_password_th
        : this.lg_reset_password = lg_reset_password.lg_reset_password_en;

        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
        async mounted(){
      this.passwordRules = this.isRequired ?[
              (v1) => !!v1 || `${this.lg_reset_password.put_required_password}`,
              (v2) =>
                !!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^()=+/_-])[A-Za-z\d@$!%*?&^()=+/_-]{8,}$/.test(v2) ||
                `${this.lg_reset_password.put_required_new_password}`,
            ]: [];

            this.passwordConfirmRules = this.isRequired2 ?[
              (v1) => this.account.password == this.account.confirm_password || `${this.lg_reset_password.put_required_confirm_password}`
            ]: [];
            
    },
        watch: {
    isRequired(val) {
      if (val) {
        this.passwordRules = this.isRequired ?[
              (v1) => !!v1 || `${this.lg_reset_password.put_required_password}`,
              (v2) =>
                !!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^()=+/_-])[A-Za-z\d@$!%*?&^()=+/_-]{8,}$/.test(v2) ||
                `${this.lg_reset_password.put_required_new_password}`,
            ]: [];
      } else {
        this.passwordRules = [];
      }
    },
     isRequired2(val) {
      if (val) {
       this.passwordConfirmRules = this.isRequired2 ?[
              (v1) => this.account.password == this.account.confirm_password || `${this.lg_reset_password.put_required_confirm_password}`
            ]: [];
      } else {
        this.passwordConfirmRules = [];
      }
    }
  },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: flex-end;
}
.v-progress-circular {
  margin: 1rem;
}
</style>
